import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginPage from "@/views/LoginPage";
import SignupPage from "@/views/SignupPage";
import Dashboard from "@/views/partner/Dashboard.vue";
import PartnerTire from "@/views/partner/PartnerTire.vue";
import PartnerSpare from "@/views/partner/PartnerSpare.vue";
import TireAdd from "@/views/partner/TireAdd.vue";
import SpareAdd from "@/views/partner/SpareAdd.vue";
import PartnerJobs from "@/views/partner/PartnerJobs.vue";
import PartnerUsers from "@/views/partner/PartnerUsers.vue";
import TireCatalog from "@/views/partner/TireCatalog.vue";
import SpareCatalog from "@/views/partner/SpareCatalog.vue";
import store from "@/store";
import ProfilePage from "@/views/partner/ProfilePage.vue";
import PartnerOrders from "@/views/partner/PartnerOrders.vue";
import PartnerOrderRequests from "@/views/partner/PartnerOrderRequests.vue";
import ParnerPurchaseOrder from "@/views/partner/ParnerPurchaseOrder.vue";
import PurchaseAdd from "@/views/partner/PurchaseAdd.vue";
import PurchaseDetail from "@/views/partner/PurchaseDetail.vue";
import AdminSpareCatalog from "@/views/admin/AdminSpareCatalog.vue";
import AdminTireCatalog from "@/views/admin/AdminTireCatalog.vue";
import AdminUsers from "@/views/admin/AdminUsers.vue";
import AdminPartners from "@/views/admin/AdminPartners.vue";
import PartnerAdd from "@/views/admin/PartnerAdd.vue";
import AdminTireBrands from "@/views/admin/AdminTireBrands.vue";
import AdminSpareBrands from "@/views/admin/AdminSpareBrands.vue";
import AdminCarBrands from "@/views/admin/AdminCarBrands.vue";
import AdminCarModels from "@/views/admin/AdminCarModels.vue";
import AdminCategories from "@/views/admin/AdminCategories.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        component: Dashboard
    },
    {
        path: '/',
        component: Dashboard
    },
    {
        path: '/partner/dashboard',
        component: Dashboard,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/tire',
        component: PartnerTire,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/tire/add',
        component: TireAdd,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/spare/add',
        component: SpareAdd,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/spare',
        component: PartnerSpare,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/jobs',
        component: PartnerJobs,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/users',
        component: PartnerUsers,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/tire-catalog',
        component: TireCatalog,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/spare-catalog',
        component: SpareCatalog,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/orders',
        component: PartnerOrders,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/order-requests',
        component: PartnerOrderRequests,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/purchase-order',
        component: ParnerPurchaseOrder,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/purchase/add',
        component: PurchaseAdd,
        meta: { isPartnerPage: true }
    },
    {
        path: '/partner/purchase/detail/:id',
        component: PurchaseDetail,
        name: 'PurchaseDetail',
        meta: { isPartnerPage: true }
    },
    {
        path: '/admin/spare/catalog',
        component: AdminSpareCatalog,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/tire/catalog',
        component: AdminTireCatalog,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/users',
        component: AdminUsers,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/partners',
        component: AdminPartners,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/partners/add',
        component: PartnerAdd,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/partners/add/:id',
        component: PartnerAdd,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/tire/brands',
        component: AdminTireBrands,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/spare/brands',
        component: AdminSpareBrands,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/car/brands',
        component: AdminCarBrands,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/car/models',
        component: AdminCarModels,
        meta: { isAdminPage: true }
    },
    {
        path: '/admin/categories',
        component: AdminCategories,
        meta: { isAdminPage: true }
    },
    {
        path: '/login',
        component: LoginPage
    },
    {
        path: '/signup',
        component: SignupPage
    },
    {
        path: '/partner/profile',
        component: ProfilePage
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if ((to.path !== '/login' && to.path !== '/signup') && !store.getters['auth/isAuthenticated']) {
        next('/login')
    } else {
        next()
    }
})


export default router
